module.exports = __webpack_public_path__ + "img/logo.e445754b.jpg";